(() => {
  const createSeparator = () => {
    const hr = document.createElement('hr');
    hr.className = 'woolnut-help-center__separator';
    hr.setAttribute('aria-hidden', 'true');
    return hr;
  };

  const wrapItem = (toggleEl) => {
    const item = document.createElement('div');
    item.className = 'woolnut-help-center__item';
    item.appendChild(toggleEl);
    item.appendChild(createSeparator());
    return item;
  };

  const setToggleSlug = (toggleEl, slug) => {
    if (!toggleEl || !slug) return;
    toggleEl.id = slug;
    toggleEl.setAttribute('data-help-slug', slug);
    const titleEl = toggleEl.querySelector('.toggle__title');
    if (titleEl && titleEl.tagName === 'A') {
      titleEl.setAttribute('href', `#${slug}`);
    }
  };

  const assignUniqueSlugs = (root) => {
    const used = new Set();

    root.querySelectorAll('.woolnut-faq__toggle[data-help-slug]').forEach((toggle) => {
      if (toggle.closest('[data-help-common-list]')) return;
      if (toggle.closest('[data-faq-search-results]')) return;

      const base = (toggle.getAttribute('data-help-slug') || 'question').trim() || 'question';
      let slug = base;
      let suffix = 2;
      while (used.has(slug)) {
        slug = `${base}-${suffix}`;
        suffix += 1;
      }
      used.add(slug);
      setToggleSlug(toggle, slug);
    });
  };

  const openToggle = (toggleEl) => {
    if (!toggleEl) return;
    const titleEl = toggleEl.querySelector('.toggle__title');
    if (!titleEl || titleEl.classList.contains('opened')) return;

    if (typeof toggleEl.onClickHandler === 'function') {
      toggleEl.onClickHandler();
      return;
    }

    titleEl.classList.add('opened');
    toggleEl.classList.add('toggle--opened');
    titleEl.setAttribute('aria-expanded', 'true');
    const contentEl = toggleEl.querySelector('.toggle__content');
    if (contentEl) contentEl.style.display = 'block';
  };

  const clearHelpSearch = (root) => {
    const input = root.querySelector('[data-faq-search-input]');
    if (!input || !input.value) return;
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const openFromHash = (root) => {
    const hash = window.location.hash.replace(/^#/, '');
    if (!hash) return false;

    const target = root.querySelector(`#${CSS.escape(hash)}.woolnut-faq__toggle`);
    if (!target) return false;

    clearHelpSearch(root);
    openToggle(target);
    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return true;
  };

  const bindTitleLinkClicks = (root) => {
    if (root.dataset.helpDeepLinkClicks === 'true') return;
    root.dataset.helpDeepLinkClicks = 'true';

    root.addEventListener('click', (event) => {
      const link = event.target.closest('a.toggle__title');
      if (!link || !root.contains(link)) return;
      // Keep href for right-click → copy link; left-click only toggles.
      event.preventDefault();
    }, true);
  };

  const initCommonQuestions = (root) => {
    if (!root || root.dataset.helpCommonInitialized === 'true') return;
    root.dataset.helpCommonInitialized = 'true';

    assignUniqueSlugs(root);
    bindTitleLinkClicks(root);

    const group = root.querySelector('[data-help-common-group]');
    const list = root.querySelector('[data-help-common-list]');
    if (!group || !list) {
      openFromHash(root);
      return;
    }

    const sources = root.querySelectorAll('[data-help-common-source]');
    if (!sources.length) {
      openFromHash(root);
      return;
    }

    const openFirst = group.getAttribute('data-help-common-open-first') === 'true';
    const hash = window.location.hash.replace(/^#/, '');
    const hashTargetsCommon = hash.indexOf('common-') === 0;
    // Avoid auto-opening the first common question when a deep link is present.
    const shouldAutoOpenFirst = openFirst && !hash;

    sources.forEach((source, index) => {
      const clone = source.cloneNode(true);
      clone.removeAttribute('data-help-common-source');
      clone.removeAttribute('data-shopify-editor-block');
      clone.classList.remove('toggle--opened');

      const sourceSlug = source.getAttribute('data-help-slug') || source.id || `question-${index}`;
      const commonSlug = sourceSlug.indexOf('common-') === 0 ? sourceSlug : `common-${sourceSlug}`;
      setToggleSlug(clone, commonSlug);

      const titleEl = clone.querySelector('.toggle__title');
      const contentEl = clone.querySelector('.toggle__content');
      if (titleEl && contentEl) {
        const contentId = `help-common-${root.dataset.sectionId || 'section'}-${index}`;
        const shouldOpen = shouldAutoOpenFirst && index === 0;
        titleEl.classList.toggle('opened', shouldOpen);
        titleEl.setAttribute('aria-expanded', String(shouldOpen));
        titleEl.setAttribute('aria-controls', contentId);
        contentEl.id = contentId;
        contentEl.style.display = shouldOpen ? 'block' : 'none';
      }

      list.appendChild(wrapItem(clone));
    });

    group.hidden = false;

    // If the hash points at a common question, prefer that over "open first".
    if (hashTargetsCommon || hash) {
      openFromHash(root);
    }
  };

  const initAll = () => {
    document.querySelectorAll('.woolnut-help-center__container').forEach(initCommonQuestions);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('hashchange', () => {
    document.querySelectorAll('.woolnut-help-center__container').forEach((root) => {
      openFromHash(root);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.woolnut-help-center__container');
    if (root) {
      delete root.dataset.helpCommonInitialized;
      delete root.dataset.helpDeepLinkClicks;
      initCommonQuestions(root);
    }
  });
})();
